import { MenuOption } from '@lexical/react/LexicalTypeaheadMenuPlugin';
import { SerializedTextNode } from 'lexical';

export type SerializedMentionNode = {
    mentionName: string;
} & SerializedTextNode;

export class MentionTypeaheadOption extends MenuOption {
    name: string;

    type: string;

    id: number;

    picture: string;

    constructor(name: string, type: string, id: number, picture: string) {
        super(name);
        this.id = id;
        this.type = type;
        this.name = name;
        this.picture = picture;
    }
}

export type MentionPluginItem = Pick<MentionTypeaheadOption, 'name' | 'type' | 'id' | 'picture'>;
